module.exports = __webpack_public_path__ + "img/pin_red.7d6304af.svg";